import { TIMEOUT_SEC } from './config';

const timeout = function (s) {
  return new Promise(function (_, reject) {
    setTimeout(function () {
      reject(new Error(`Request took too long! Timeout after ${s} second`));
    }, s * 1000);
  });
};

export const AJAX = async function (url, uploadData = undefined) {
  try {
    const fetchPro = uploadData
      ? fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(uploadData),
        })
      : fetch(url);

    const response = await Promise.race([fetchPro, timeout(TIMEOUT_SEC)]);

    const data = await response.json();

    if (!response.ok) throw new Error(`${data.message} (${response.status})`);

    if (!data || (data.hasOwnProperty('results') && data.results === 0))
      throw new Error(`No Recipes found!`);

    return data;
  } catch (error) {
    throw error;
  }
};

// Code deprecated and refactored as above
// export const getJSON = async function (url) {
//   try {
//     const response = await Promise.race([fetch(url), timeout(TIMEOUT_SEC)]);

//     const data = await response.json();

//     if (!response.ok) throw new Error(`${data.message} (${response.status})`);

//     if (!data || (data.hasOwnProperty('results') && data.results === 0))
//       throw new Error(`No Recipes found!`);

//     return data;
//   } catch (error) {
//     throw error;
//   }
// };

// export const sendJSON = async function (url, uploadData) {
//   try {
//     const fetchPro = fetch(url, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(uploadData),
//     });

//     const response = await Promise.race([fetchPro, timeout(TIMEOUT_SEC)]);

//     const data = await response.json();

//     if (!response.ok) throw new Error(`${data.message} (${response.status})`);

//     if (!data || (data.hasOwnProperty('results') && data.results === 0))
//       throw new Error(`No Recipes found!`);

//     return data;
//   } catch (error) {
//     throw error;
//   }
// };
